<template>
  <v-card class="pa-4" elevation="1">
    <!-- Cabeçalho -->
    <v-row class="justify-space-between align-center mb-4">
      <span class="font-weight-medium">Status de Formações</span>
      <v-btn outlined small color="black" @click="onVisualizarListagem">Visualizar Listagem</v-btn>
    </v-row>

    <v-row no-gutters class="mb-1">
      <div
        v-for="status in statusList"
        :key="status.label"
        class="text-center caption"
        style="flex: 1; padding:1.5rem 0;"
      >
        {{ status.label }}
      </div>
    </v-row>

    <v-row no-gutters class="rounded overflow-hidden status-bar mb-2">
      <div
        v-for="status in statusList"
        :key="status.label"
        class="status-segment white--text d-flex align-center justify-center"
        :style="{ backgroundColor: status.color, flex: 1 }"
      >
        {{ status.value }}
      </div>
    </v-row>

    <v-alert
      type="info"
      border="top"
      dense
      text
      class="grey lighten-3 caption mt-2 pa-2 d-flex align-center justify-center"
    >
      Dados refletem a situação até o dia {{ dataHoraInfo }}
    </v-alert>
  </v-card>
</template>

<script>
export default {
  props: {
    statusList: {
      type: Array,
      required: true
    },
    dataHoraInfo:{
      type: String,
      required: true
    }
  },
  methods: {
    onVisualizarListagem() {
      this.$emit('visualizar-listagem');
    }
  }
}
</script>

<style scoped>
.status-bar {
  height: 16px;
}

.status-segment {
  font-size: 11px;
}
</style>
